// 260810nrai: AZ Storno-Anfrage modal (lead picker for reversed Portunus / AD)

function populateAzReversalLeadSelect(leads, selectedEmployeeId) {
  const $select = $('#az_reversal_request_lead_select');
  const $receiver = $('#az_reversal_request_receiver');
  $select.empty();

  (leads || []).forEach((lead) => {
    const option = $('<option></option>')
      .val(String(lead.employee_id))
      .text(lead.receiver_name || '');
    $select.append(option);
  });

  const selectedId = selectedEmployeeId || (leads && leads.length ? leads[0].employee_id : null);
  if (selectedId) {
    $select.val(String(selectedId));
  }

  const showPicker = (leads || []).length > 1;
  if (showPicker) {
    $receiver.hide().text('');
    $select.show();
  } else {
    const singleLead = (leads || [])[0];
    $receiver.text(singleLead ? (singleLead.receiver_name || '') : '').show();
    $select.hide();
  }

  $('#az_reversal_request_lead_employee_id').val($select.val() || (selectedId ? String(selectedId) : ''));
}

function showAzReversalRequestToast(message, kind, retried) {
  if (!message) { return; }
  if (window.toast_manager && typeof window.toast_manager.push_many === 'function') {
    window.toast_manager.push_many([{
      kind: kind || 'success',
      html: message,
      duration_ms: 5000
    }]);
    return;
  }
  if (!retried) {
    window.setTimeout(function () { showAzReversalRequestToast(message, kind, true); }, 50);
    return;
  }
  const $zone = $('#flash_zone');
  if ($zone.length) {
    $zone.html(`<div class="flash ${kind === 'error' ? 'error' : 'notice'}">${message}</div>`);
  }
}

// 260819nrai: nach Reload der AZ-Liste den Erfolgstoast nachziehen (flash_zone fehlt sonst / Reload löscht den Client-Toast)
const AZ_REVERSAL_PENDING_TOAST_KEY = 'badok_az_reversal_pending_toast';

function persistAzReversalRequestToast(message, kind) {
  if (!message) { return; }
  try {
    sessionStorage.setItem(AZ_REVERSAL_PENDING_TOAST_KEY, JSON.stringify({
      html: message,
      kind: kind || 'success'
    }));
  } catch (e) {}
}

function consumeAzReversalRequestToast() {
  let raw;
  try {
    raw = sessionStorage.getItem(AZ_REVERSAL_PENDING_TOAST_KEY);
    if (!raw) { return; }
    sessionStorage.removeItem(AZ_REVERSAL_PENDING_TOAST_KEY);
  } catch (e) {
    return;
  }
  try {
    const payload = JSON.parse(raw);
    if (payload && payload.html) {
      showAzReversalRequestToast(payload.html, payload.kind);
    }
  } catch (e) {}
}

function azReversalRequestFieldsValid() {
  const subject = ($('#az_reversal_request_subject').val() || '').trim();
  const begruendung = ($('#az_reversal_request_body').val() || '').trim();
  if (subject && begruendung) {
    $('#az_reversal_request_error').hide().text('');
    return true;
  }
  const missing = [];
  if (!subject) { missing.push('Betreff'); }
  if (!begruendung) { missing.push('Begründung'); }
  $('#az_reversal_request_error')
    .text(`Es fehlen notwendige Angaben: ${missing.join(', ')}.`)
    .show();
  return false;
}

export function azStornoRequestOpen(el) {
  const $el = $(el);
  const azId = $el.attr('data-az-id');
  const modal = $('#az_reversal_request_modal');
  if (!azId || !modal.length) { return false; }

  $('#az_reversal_request_error').hide().text('');
  $('#az_reversal_request_send').addClass('disabled');

  $.post('/azs/reversal_request_form', { az_id: azId })
    .done((data) => {
      if (data && data.success === false) {
        showAzReversalRequestToast('Kein Empfänger mit Storno-Berechtigung gefunden.', 'error');
        return;
      }
      populateAzReversalLeadSelect(data.leads || [], data.lead_employee_id);
      $('#az_reversal_request_subject').val(data.subject || '');
      $('#az_reversal_request_body').val(data.body || '');
      $('#az_reversal_request_az_id').val(data.az_id || azId);
      $('#az_reversal_request_send').removeClass('disabled');
      modal.foundation('reveal', 'open');
      setTimeout(function () {
        $('#az_reversal_request_body').trigger('focus');
      }, 200);
    })
    .fail((xhr) => {
      const err = xhr && xhr.responseJSON && xhr.responseJSON.error;
      const msg = err === 'no_leads'
        ? 'Kein Empfänger mit Storno-Berechtigung gefunden.'
        : 'Die Storno-Anfrage konnte nicht geöffnet werden.';
      showAzReversalRequestToast(msg, 'error');
    });
  return false;
}

function sendAzReversalRequest() {
  if (!azReversalRequestFieldsValid()) { return; }

  const payload = {
    az_id: $('#az_reversal_request_az_id').val(),
    lead_employee_id: $('#az_reversal_request_lead_employee_id').val() || $('#az_reversal_request_lead_select').val(),
    subject: ($('#az_reversal_request_subject').val() || '').trim(),
    body: ($('#az_reversal_request_body').val() || '').trim()
  };

  $('#az_reversal_request_error').hide().text('');
  $('#az_reversal_request_send').addClass('disabled');

  $.post('/azs/reversal_request_send', payload)
    .done((data) => {
      $('#az_reversal_request_modal').foundation('reveal', 'close');
      const message = data && data.message;
      // 260819nrai: AZ-Seite hat die Liste nur nach Reload aktuell; Toast über sessionStorage nachziehen
      const shouldReload =
        (window.location && String(window.location.pathname).indexOf('/azs') !== -1) ||
        $('#aggregation_status_and_workflow_steps').length > 0;
      if (shouldReload) {
        persistAzReversalRequestToast(message, 'success');
        window.location.reload();
        return;
      }
      showAzReversalRequestToast(message, 'success');
    })
    .fail((xhr) => {
      const message = (xhr.responseJSON && xhr.responseJSON.error === 'missing_fields')
        ? 'Betreff und Begründung sind erforderlich.'
        : ((xhr.responseJSON && xhr.responseJSON.error) || 'Die Nachricht konnte nicht gesendet werden.');
      $('#az_reversal_request_error').text(message).show();
    })
    .always(() => {
      $('#az_reversal_request_send').removeClass('disabled');
    });
}

export function initAzReversalRequest() {
  consumeAzReversalRequestToast();

  $(document).off('change.azReversalRequest', '#az_reversal_request_lead_select')
    .on('change.azReversalRequest', '#az_reversal_request_lead_select', function () {
      $('#az_reversal_request_lead_employee_id').val($(this).val() || '');
    });

  $(document).off('click.azReversalRequestSend', '#az_reversal_request_send')
    .on('click.azReversalRequestSend', '#az_reversal_request_send', function (event) {
      event.preventDefault();
      if ($(this).hasClass('disabled')) { return; }
      sendAzReversalRequest();
    });

  $(document).off('click.azReversalRequestCancel', '.az_reversal_request_cancel')
    .on('click.azReversalRequestCancel', '.az_reversal_request_cancel', function (event) {
      event.preventDefault();
      $('#az_reversal_request_modal').foundation('reveal', 'close');
    });
}
